export function getPortfolioSummary() {
    return window.axios.get('portfolio/summary').then((response) => {
        return response.data.data
    })
}

export function getPortfolioPositions() {
    return window.axios.get('portfolio/positions').then((response) => {
        return response.data.data
    })
}

export function getUserPortfolio(user_name) {
    return window.axios.get(`portfolio/user/${user_name}`).then((response) => {
        return response.data.data
    })
}

export function getPortfolioOrders(params) {
    return window.axios.get('portfolio/orders', { params }).then((response) => {
        return response.data.data
    })
}

export function createOrder(data) {
    return window.axios.post('portfolio/orders', data).then((response) => {
        return response.data.data
    })
}

export function cancelOrder(orderId) {
    return window.axios.post(`portfolio/orders/${orderId}/cancel`).then((response) => {
        return response.data.data
    })
}

export function getInstrument(assetId) {
    return window.axios.get(`instruments/${assetId}`).then((response) => {
        return response.data.data
    })
}

export function getInstrumentHistory(assetId, range = '1M') {
    return window.axios.get(`instruments/${assetId}/history`, { params: { range } }).then((response) => {
        return response.data.data
    })
}

export function searchInstruments(query) {
    return window.axios.get('instruments/search', { params: { q: query } }).then((response) => {
        return response.data.data
    })
}

export function browseInstruments(params) {
    return window.axios.get('instruments/browse', { params }).then((response) => {
        return response.data.data
    })
}

export function getTickers(offset = 0, limit = 50) {
    return window.axios.get('tickers', { params: { offset, limit } }).then((response) => {
        return response.data.data
    })
}

let __tickersCache = null
let __tickersCacheAt = 0
let __tickersInflight = null

export function getTickersAll(limit = 200) {
    const now = Date.now()
    if (__tickersCache && (now - __tickersCacheAt) < 60000) {
        return Promise.resolve(__tickersCache)
    }
    if (__tickersInflight) {
        return __tickersInflight
    }
    __tickersInflight = window.axios.get('tickers', { params: { offset: 0, limit } }).then((response) => {
        __tickersCache = response.data.data
        __tickersCacheAt = Date.now()
        __tickersInflight = null
        return __tickersCache
    }).catch((err) => {
        __tickersInflight = null
        throw err
    })
    return __tickersInflight
}

export function getTradingView(symbol) {
    return window.axios.get(`trade/${symbol}`).then((response) => {
        return response.data.data
    })
}

export function getChartData(assetId, range = '1M') {
    return window.axios.get(`chart/${assetId}`, { params: { range } }).then((response) => {
        return response.data.data
    })
}
